import type { Tokens } from '@zeus/themes';

export function createSpacing(tokens: Tokens) {
  return Number(tokens.spacing.base);
}
